import { render, staticRenderFns } from "./SmChartReservesPayments.vue?vue&type=template&id=976cceb2&scoped=true&"
import script from "./SmChartReservesPayments.vue?vue&type=script&lang=ts&"
export * from "./SmChartReservesPayments.vue?vue&type=script&lang=ts&"
import style0 from "./SmChartReservesPayments.vue?vue&type=style&index=0&id=976cceb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976cceb2",
  null
  
)

export default component.exports